import EditPenIcon from "/assets/icons/edit-pen.png";

interface IContextEditViewProps {
  label?: string;
  content: string;
  onClickToModify?: () => void;
}

/**
 * Instruction bar shown above comparison results.
 * Displays the user's last prompt and a button to modify it.
 */
const ContextEditView = ({ label = 'Your Instruction:', content, onClickToModify }: IContextEditViewProps) => {
  return (
    <div className="border-b border-gray-100 bg-gray-50">
      <div className="px-4 py-3">
        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
          {label}
        </span>
        <div className="flex items-start justify-between gap-2 mt-1">
          <p className="text-xs text-brand-600 font-medium leading-relaxed line-clamp-2 flex-1">
            {content}
          </p>
          <button
            onClick={onClickToModify}
            disabled={!onClickToModify}
            title="Modify instruction"
            className="flex-shrink-0 p-1.5 rounded-lg hover:bg-brand-50 text-gray-400 hover:text-brand-500 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
            aria-label="Modify instruction"
          >
            <img src={EditPenIcon} alt="" className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContextEditView;
